import type { TranslationFunction } from '@/app/components/translations/Translation';

export function getClassKey(airlineClass: string): string {
  const airlineClasses: { [key: string]: string | null } = {
    Y: 'vacation.journey.class.tourist',
    P: 'vacation.journey.class.touristpremium',
    C: 'vacation.journey.class.business',
    F: 'vacation.journey.class.firstclass',
  };
  return `${airlineClasses[airlineClass]}` || 'vacation.journey.class.tourist';
}

export function getBoundDepartureCity(boundData: TransportBoundType) {
  return getSegmentDepartureCity(boundData.segments[0]);
}

export function getBoundArrivalCity(boundData: TransportBoundType) {
  return getSegmentArrivalCity(boundData.segments[boundData.segments.length - 1]);
}

export function getSegmentDepartureCity(segment: TransportSegment) {
  return segment.departureHub.cityName || segment.departureHub.name || segment.departureHub.id;
}

export function getSegmentArrivalCity(segment: TransportSegment) {
  return segment.arrivalHub.cityName || segment.arrivalHub.name || segment.arrivalHub.id;
}

export function isBelgiumTrainsSpecialFare(trainTransport: TransportsType | undefined) {
  return trainTransport?.fareDetails?.includes('ALL_BELGIAN_STATIONS');
}

export function isNotHotelInBrussels(
  trainTransport: TransportsType | undefined,
  destinationCity: string | undefined | null
) {
  const BRUSSELS_DESTINATION_CODE = 'ZYR';
  const BRUSSELS_CITY_ID = '153242';

  return trainTransport?.outbound.destination === BRUSSELS_DESTINATION_CODE && destinationCity !== BRUSSELS_CITY_ID;
}

export function getPriceTypeText(t: TranslationFunction, priceType: string) {
  const key =
    priceType === 'TOTAL'
      ? 'vacation.common.price.total'
      : priceType === 'PER_PERSON'
        ? 'vacation.select.room.price.dp.perperson.short'
        : priceType === 'PER_ROOM_NIGHT'
          ? 'vacation.common.price.per_room_night'
          : '';
  return t(key);
}
